import { render } from "./MediaModal.vue?vue&type=template&id=3ee83ff8&ts=true"
import script from "./MediaModal.vue?vue&type=script&lang=ts"
export * from "./MediaModal.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src754147292/src/web-ext-galaxycorp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__